import React from "react";
import moment from "moment";

import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
} from "antd";
import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
  GREATER_THAN_ZERO
} from "../../../common/types/regularExpresionType";
import {
  BOLETA_DE_VENTA,
} from "../../../common/types/tipoComprobanteType";
import dialog from "../../../common/utility/dialog";
import Cuotas from "./FormModal/Cuotas";


const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class VincularModal extends React.Component {
  constructor(props) {

    super(props);
    this.state = {
      result: "No result",
      tiposComprobante: false,
      isCredito: false,
    };
  }


  //#region  [REGISTRO DE DATO]

  handleOk = (e) => {
    e.preventDefault();


    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values);
      if (!err) {
        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante.key,
          idFormaPago: values.idFormaPago == undefined ? 0 : values.idFormaPago.key,
          serie: values.serie.toUpperCase(),
          documento: values.documento,
          fechaDocumentoStr: values.fechaDocumentoStr.format("DD/MM/YYYY"),
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          tipoCambio: parseFloat(values.tipoCambio),
          listaComprobanteCuota: this.fetchCuotas(values),

        };

        if (data.idFormaPago == 2 && data.listaComprobanteCuota.length == 0) {
          dialog.warning("Agrega detalle cuota.");
          return false;
        }

        var totalCuotas = 0;

        if (data.listaComprobanteCuota.length > 0) {

          totalCuotas = parseFloat(data.listaComprobanteCuota.reduce((a, b) => a + (b["montoCuota"] || 0), 0));

          if (totalCuotas != parseFloat(this.props.formValues.sumaTotal)) {
            dialog.warning("El monto ingresado debe ser igual al monto del documento.");
            return false;
          }
        }
        if (data.idFormaPago == 2) {
          var latest = data.listaComprobanteCuota[data.listaComprobanteCuota.length - 1].fechaVencimientoStr;
          if (data.fechaVencimientoStr != latest) {
            dialog.warning("La ultima cuota debe tener la fecha igual que la fecha de vencimiento del documento");
            return false;
          }
        }


        // CONTADO PENDIENTE DE PAGO (NO)
        /*      if (idTipoComprobante==) {
               dialog.warning("Por favor agregue el método de pago.");
               return false;
             } */


        this.props.onSave(data, this.props.form);
      }
    });
  };


  fetchCuotas = (values) => {
    var result = [];

    if (values.idTipoComprobante != BOLETA_DE_VENTA.ID) {
      var flagCuota = this.props.form.getFieldValue("flagCuota");

      if (values.arrVencimiento === undefined || values.arrMontoCuota === undefined)
        return result;

      var keys = [];
      var obj = Object.assign({}, values.arrVencimiento);

      for (var [key] of Object.entries(obj)) {
        keys.push(key);
      }
      keys.forEach((key) => {
        result.push({
          fechaVencimientoStr:
            values.arrVencimiento[key].format("DD/MM/YYYY"),
          correlativo: parseFloat(values.arrCorrelativo[key]),
          montoCuota: parseFloat(values.arrMontoCuota[key]),
        });
      });
    }

    return result;
  };


  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  onChange = (e) => {
    if (e != undefined) {
      var tiposComprobante = (e == 4 ? false : true);
      this.setState({
        tiposComprobante
      })
    }
  }

  onChangeCredito = (e) => {
    debugger
    if (e != undefined) {
      var isCredito = (e == 1 ? false : true);

      if (!isCredito) {
        this.props.onRemoverCuota();

        this.setState({
          isCredito
        })
      } else {

        this.setState({
          isCredito
        })
      }

    }
  }


  completeDocumento = (e) => {
    var value = e.target.value;
    if (value.length === 0) return;

    var zeros = "";
    for (let index = 0; index < 8 - value.length; index++) {
      zeros += "0";
    }
    this.props.form.setFieldsValue({ documento: zeros + value }, () => {
      this.props.form.validateFields(["documento"], { force: true });
    });
  };

  documentoCustomValidation = (rule, value, callback) => {
    if (value === "00000000") callback("Documento no válido");

    callback();
  };
  //#endregion


  render() {
    const {
      getFieldDecorator,
      setFieldsValue,
      getFieldValue,
    } = this.props.form;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });



    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });

    getFieldDecorator("sumaIsc", {
      initialValue: 0
    });

    return (
      <Modal
        title={'Vincular Comprobante'}
        visible={this.props.visible}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="ok"
            type="primary"
            loading={this.props.formValues.saveLoading}
            onClick={this.handleOk}
          >
            Guardar
          </Button>,
        ]}
        style={{ top: 30 }}
        width="1100px"
      >

        <Form>
          <div className="row">
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        }
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                        {
                          required: true,
                          pattern: new RegExp(GREATER_THAN_ZERO),
                          message: "Campo Obligatorio"
                        }
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-4 form-group">
              <Form.Item label="Fecha de Registro">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("fechaDocumentoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaDocumentoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha de recepción"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>


            <div className="col-md-4 form-group">
              <Form.Item label="Tipo Comprobante">
                {getFieldDecorator("idTipoComprobante", {
                  initialValue: this.props.formValues.idTipoComprobante
                    ? { key: this.props.formValues.idTipoComprobante }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Tipo de Comprobante"}
                    optionFilterProp="children"
                    onChange={(option) => this.onChange(option.key)}
                  >
                    {this.props.tiposComprobante.map((item) => (
                      (item.codigoSunat == "01" || item.codigoSunat == "03") ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option> : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>


            <div className="col-md-4 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Requerido",
                          whitespace: true,
                        },
                        // {
                        //   validator: this.serieCustomValidation,
                        // },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        maxLength={4}
                        style={{ textTransform: "uppercase" }}
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                      rules: [
                        {
                          validator: this.documentoCustomValidation,
                        },
                        {
                          required: true,
                          message: "Requerido",
                          whitespace: true,
                        }
                      ],
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        onBlur={this.completeDocumento}
                        maxLength={8}
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-4 form-group">
              {this.state.tiposComprobante ?
                <Form.Item label="Forma de Pago">
                  {getFieldDecorator("idFormaPago", {
                    initialValue: this.props.formValues.idFormaPago
                      ? { key: this.props.formValues.idFormaPago }
                      : undefined,
                    rules: [
                      {
                        required: true,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Forma Pago"}
                      optionFilterProp="children"
                      onChange={(option) => this.onChangeCredito(option.key)}
                    >
                      {this.props.formasPago.map((item) => (

                        <Option key={item.id} value={item.id}>
                          {item.nombre}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
                : null}
            </div>
          </div>


          <div className="row">
            <div className="col-md-12 form-group">
              <Tabs
                activeKey={"1"}
                tabBarExtraContent={
                  <div className="custom-options">

                    {this.state.tiposComprobante ?
                      <Button
                        icon="plus"
                        type="primary"
                        disabled={!this.state.isCredito}
                        onClick={this.props.onAgregarDetalle}
                      >
                        Agregar
                      </Button> : null
                    }


                  </div>
                }
              >

                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Cuotas
                    </span>
                  }
                  key="1"
                >
                  <Cuotas

                    dataSource={this.props.listaComprobanteCuota}
                    onRemove={this.props.onRemoverCuota}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>


              </Tabs>
            </div>
          </div>


          <div className="row">
            <div className={"col-md-9"}>
              {/*         <Form.Item>
                <InputGroup compact>
                  {
                    this.props.formValues.fechaStr === FACTURA.ID ?
                      <Form.Item style={{ width: '20%' }}>
                        {props.onGetFieldDecorator('flagDetraccion', {
                          initialValue: this.props.formValues.flagDetraccion,
                          valuePropName: 'checked'
                        })(
                          <Checkbox
                            onChange={(e) => props.onChangeTotals("flagDetraccion", e.target.checked)}
                          >
                            Detracción
                          </Checkbox>
                        )}
                      </Form.Item> : null
                  }

                </InputGroup>
              </Form.Item> */}
            </div>

            <div className="col-md-3 pt-10">

              {
                this.props.formValues.flagDetraccion ?
                  <div className="col text-right mb-5">
                    <div className="total-inline">
                      <label>Porcentaje Detracción</label>
                      <div>{getFieldValue('porcentajeDetraccion')}</div>
                    </div>
                  </div> : null
              }
              <div className="col text-right mb-5">
                <div className="total-inline">
                  <label>Total Detalle</label>
                  <div>{getFieldValue('sumaTotalDetalle')}</div>
                </div>
              </div>
              <div className="col text-right mb-5">
                <div className="total-inline">
                  <label>Sub Total</label>
                  <div>{getFieldValue('sumaSubTotal')}</div>
                </div>
              </div>
              <div className="col text-right mb-5">
                <div className="total-inline">
                  <label>IGV</label>
                  <div>{getFieldValue('sumaIgv') === "-0.00" ? "0.00" : getFieldValue('sumaIgv')}</div>
                </div>
              </div>
              {/*          <div className="col text-right mb-5">
                <div className="total-inline">
                  <label>ISC</label>
                  <div>{getFieldValue('sumaIsc')}</div>
                </div>
              </div> */}
              <div className="col text-right mb-5">
                <div className="total-inline">
                  <label>Total</label>
                  <div>{getFieldValue('sumaTotal')}</div>
                </div>
              </div>


              {/*         {
                props.onGetFieldValue('idTipoComprobante') && props.onGetFieldValue('flagDetraccion') ?
                  <div className="col text-right mb-5">
                    <div className="total-inline">
                      <label>Importe Detracción</label>
                      <div>{props.onGetFieldValue('importeDetraccion').toFixed(2)}</div>
                    </div>
                  </div> : null
              } */}

            </div>
          </div>



        </Form>
      </Modal>
    );
  }
}

export default Form.create()(VincularModal);